import { z } from 'zod'
import type { JoinUs } from '@/models/api/join-us'
import {
  apiValidator,
  type ApiFactory,
  type ApiRequestConfig,
  type ApiResponse
} from '~library/services'

export default class JoinUsApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 加入我們
   * https://hackmd.io/kwj1fmVLS8OwKQjvb1lCOw
   */
  @apiValidator(z.object({ corporateId: z.string() }))
  createData(
    data: JoinUs,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<{ corporateId: string }>> {
    return this.api.createData('Corporate/JoinUs', data, config)
  }
}
